import React from 'react';
import {Button} from 'MWComponents';
import { termsDataMonths } from "../../enums/termsData";

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model,
        { mode } = model,
        ur = "account_credit_limit_ur",
        fop = "account_credit_limit_fop",
        desc = mode === ur ? calc.l10n("CALCULATOR_CREDIT_SUM_LF") : calc.l10n("CALCULATOR_CREDIT_SUM_FOP"),
      amountBtns = (
        <div className="calculator-amount-wrapper">
            <button className={`amount-btn ${50000 === Number(model.getCreditSum()) ? 'active' : ''}`} name="creditSum"  onClick={calc.handleChange} value={50000}>
                {(50000).toLocaleString() + ' ' + calc.l10n('UAH_ICON')}
            </button>
            <button className={`amount-btn ${100000 === Number(model.getCreditSum()) ? 'active' : ''}`} name="creditSum"  onClick={calc.handleChange} value={100000}>
                {(100000).toLocaleString() + ' ' + calc.l10n('UAH_ICON')}
            </button>
            <button className={`amount-btn ${250000 === Number(model.getCreditSum()) ? 'active' : ''}`} name="creditSum"  onClick={calc.handleChange} value={250000}>
                {(250000).toLocaleString() + ' ' + calc.l10n('UAH_ICON')}
            </button>
        </div>
      ),
      termBtns = (
        <div className="calculator-terms-wrapper">
            <button className={`term-btn ${1 === Number(model.getTerm()) ? 'active' : ''}`} name="term" onClick={calc.handleChange} value={1}>
              {"1"} {calc.l10n('CALCULATOR_DAY')}
            </button>
            <button className={`term-btn ${14 === Number(model.getTerm()) ? 'active' : ''}`} name="term" onClick={calc.handleChange} value={14}>
              {"14"} {calc.l10n('CALCULATOR_DAYS')}
            </button>
            <button className={`term-btn ${30 === Number(model.getTerm()) ? 'active' : ''}`} name="term" onClick={calc.handleChange} value={30}>
              {"30"} {calc.l10n('CALCULATOR_DAYS')}
            </button>
            <button className={`term-btn ${60 === Number(model.getTerm()) ? 'active' : ''}`} name="term" onClick={calc.handleChange} value={60}>
              {"60"} {calc.l10n('CALCULATOR_DAYS')}
            </button>
            <button className={`term-btn ${90 === Number(model.getTerm()) ? 'active' : ''}`} name="term" onClick={calc.handleChange} value={90}>
              {"90"} {calc.l10n('CALCULATOR_DAYS')}
            </button>
        </div>
      );

    return (
        <React.Fragment>
            <div className="calculator-controllers">
                <p className="calc-title" dangerouslySetInnerHTML={{__html: calc.l10n('CREDIT_CALCULATOR_NAME')}}></p>
                {/*<div className="mode-switchers">*/}
                {/*    <button name={ur}*/}
                {/*            className={`${mode === ur && "selected"} btn-transparent`}*/}
                {/*            onClick={calc.toggleMode}>*/}
                {/*        {calc.l10n("CALCULATOR_CREDIT_LF")}*/}
                {/*    </button>*/}
                {/*    <button name={fop}*/}
                {/*            className={`${mode === fop && "selected"} btn-transparent`}*/}
                {/*            onClick={calc.toggleMode}>*/}
                {/*        {calc.l10n("CALCULATOR_CREDIT_FOP")}*/}
                {/*    </button>*/}
                {/*</div>*/}
                <div className="controller-block">
                    <div className="calc-block-title" dangerouslySetInnerHTML={{__html: desc}}></div>

                    <div className="calculator-slider-wrapper">
                        <div className="calculator-input-wrapper">
                            <input name="creditSum" type="text"
                                   className="calculator-slider-value"
                                   value={model.getCreditSum().toLocaleString('uk-UA')}
                                   onChange={calc.handleChangeInput}
                                   onBlur={calc.blurChangeInput}>
                            </input>
                            <span ref={calc.hiddenValue} className='hidden-value'>{model.getCreditSum().toLocaleString('uk-UA')}</span>
                            <span style={{left: `${calc.state.valueWith}px`}}>{calc.l10n('UAH_ICON')}</span>
                        </div>
                        <div className="calculator-slider">
                            <input type="range"
                                   name="creditSum"
                                   className="calculator-sum-slide"
                                   onChange={calc.handleChange}
                                   value={model.getCreditSum()}
                                   min={model.getMinSumEdge()}
                                   max={model.getMaxSumEdge()}
                                   step={model.getSumStep()}
                            />
                        </div>
                    </div>
                </div>
                {amountBtns}
                <div className="controller-block">
                    <div className="calc-block-title" dangerouslySetInnerHTML={{__html: calc.l10n('CALCULATOR_CREDIT_PERIOD')}}></div>

                    <div className="calculator-slider-wrapper">
                        <div className="calculator-input-wrapper">
                            <input name="term" type="text"
                                   className="calculator-slider-value"
                                   value={model.getTerm()}
                                   onChange={calc.handleChangeInput}
                                   onBlur={calc.blurChangeInput}>
                            </input>
                            <span className='hidden-value'>{model.getTerm()}</span>
                            <span style={{left: calc.l10n(model.getDay()).length + 24}}>{ calc.l10n(model.getDay())}</span>
                        </div>

                        <div className="calculator-slider">
                            <input type="range"
                                   name="term"
                                   className="calculator-sum-slide"
                                   onChange={calc.handleChange}
                                   value={model.getTerm()}
                                   min={model.getTerms()[0]}
                                   max={model.getTerms()[1]}
                                   step={1}
                            />
                        </div>

                    </div>
                </div>
              {termBtns}
            </div>
        </React.Fragment>
    );
}
